module.exports = __webpack_public_path__ + "static/media/_23.3790f323.jpg";